import { ListActionsService } from './../../../../services/list-actions.service';
import { Component, OnInit, Input } from '@angular/core';
import { TableConfigs } from '../../../../../common/components/data-table/data-table.component';
import { ModalService } from '../../../../../services/modal.service';
import { CurrencyPipe, DecimalPipe } from '@angular/common';
import { PlannerEndpoints } from 'src/app/planner/constants/planner-endpoints.const';
import { PlanStatus } from '../../../planner-edit/constants/PlanStatus.const';
import { ChannelConst } from '../../../planner-edit/constants/Channel.const';
import * as moment from 'moment';
import * as _ from 'lodash';
import { PlanConfigVO } from 'src/app/planner/interfaces/vo/PlanConfigVO';
import { CampaignPreviewVO } from 'src/app/planner/interfaces/vo/CampaignPreviewVO';
import { InvSrcAllocationResultVO } from 'src/app/planner/interfaces/vo/InvSrcAllocationResultVO ';

@Component({
  selector: 'io-preview',
  templateUrl: './io-preview.component.html',
  styleUrls: ['./io-preview.component.scss']
})
export class IoPreviewComponent implements OnInit {

  @Input() public ioPreviewData: CampaignPreviewVO;
  @Input() public planDetails: PlanConfigVO;
  @Input() public openAuction: InvSrcAllocationResultVO;

  public buttonLabel: string;
  waitingForActivation: boolean = false;
  disableButtonWhenPlanHasPastDate: boolean;
  disableButtonWhenLessMaxBid: boolean;
  disabledButtonTitleText: string;
  maxBid: number;
  public ioPreviewTableConfigs: TableConfigs = {
    disableSorting: true,
    uniqueIdAccessor: 'name',
    pageSize: 25, // default to 25
    isSelectionEnabled: false,
    isPaginationEnabled: false,
    showSummaryRow: false,
    stickyColumnHeaders: true,
    endpoint: null,
    fetchStaticData: () => {
      return new Promise((resolve) => {
        resolve(
          this.ioPreviewData
        )
      })
    }
  };

  public ioPreviewColumns: any[] = [
    {
      Header: 'Line Name',
      accessor: 'name',
      id: 'name',
      width: 450
    },
    {
      Header: 'Format',
      accessor: row => {
        return Object.values(ChannelConst).find(channel => channel.id === row.format).label;
      },
      id: 'format'
    },
    {
      Header: 'Budget',
      accessor: row => {
        if (row.budget) {
          return this.currencyPipe.transform(row.budget, this.planDetails.currency, 'symbol', '1.2');
        } else {
          return '-'
        }
      },
      id: 'budget'
    },
    {
      Header: 'eCPM',
      accessor: row => {
        if (row.targetedAvgBid) {
          return this.currencyPipe.transform(row.targetedAvgBid, this.planDetails.currency, 'symbol', '1.2');
        } else {
          return '-'
        }
      },
      id: 'targetedAvgBid'
    },
    {
      Header: 'Impressions',
      accessor: row => {
        return row.estimatedImpressions ? this.decimalPipe.transform(row.estimatedImpressions, '1.0-2') : '-';
      },
      id: 'estimatedImpressions'
    }
    // {
    //   Header: 'Pacing Type',
    //   accessor: 'pacingType',
    //   id: 'pacingType'
    // }
  ];
  currentDate: any;

  constructor(
    private modal: ModalService,
    private currencyPipe: CurrencyPipe,
    private decimalPipe: DecimalPipe,
    private listActionService: ListActionsService
  ) { }

  ngOnInit() {
    this.currentDate = moment.valueOf();
    this.maxBid = this.planDetails.channelPlan.digital.tactics[0].maxBid;
    if (this.planDetails.status !== PlanStatus.Activated.key) {
      this.buttonLabel = 'Create Order';
    } else {
      this.buttonLabel = 'Go to Campaigns';
    }
    this.disableSendToCampaignButton();
  }

  //Disable Create Order button if plan is preview ready and if it has past start date or end date
  //or plan max bid < LP generate bid price
  disableSendToCampaignButton() {
    this.disableButtonWhenPlanHasPastDate = (moment(this.planDetails.flightSchedule.startDate).valueOf() < this.currentDate) ||
      (moment(this.planDetails.flightSchedule.endDate).valueOf() < this.currentDate);

    this.disableButtonWhenLessMaxBid = this.maxBid && (this.openAuction && _.size(this.openAuction.results)
      && this.openAuction.results.findIndex((item) => item.averageCPM > this.maxBid) > -1);

    if (this.disableButtonWhenPlanHasPastDate) {
      this.disabledButtonTitleText = "The flight schedule of this plan is already in the past. Please copy this plan, update the flight schedule and generate a new plan";
    } else if (this.disableButtonWhenLessMaxBid) {
      this.disabledButtonTitleText = "Cannot create order. Max bid must be higher than all inventory source eCPM values in the plan";
    }
  }

  sendToCampaigns() {
    if (this.waitingForActivation || this.disableButtonWhenPlanHasPastDate || this.disableButtonWhenLessMaxBid) {
      if (this.disabledButtonTitleText) {
        this.modal.error({
          message: this.disabledButtonTitleText
        });
      }
      return;
    } else {
      if (this.planDetails.status !== PlanStatus.Activated.key) {
        this.modal.confirmation({ message: 'A new insertion order will be created and made avaiable for activated in campaigns?' },
          () => {
            this.waitingForActivation = true;
            this.listActionService.listActionUpdate(PlannerEndpoints.planActivate, [this.planDetails.id], true).then((response: any) => {
              this.planDetails.status = PlanStatus.Activated.key;
              this.buttonLabel = 'Go to Campaigns';
              this.waitingForActivation = false;
              if (!this.planDetails.activation) {
                this.planDetails.activation = {};
              }
              this.planDetails.activation.DigitalVideo = response.result.ioDashboardUrl;
            }).catch(() => {
              this.waitingForActivation = false;
            });
          }
        )
      } else {
        let activation: any = this.planDetails.activation;
        if (activation && activation.DigitalVideo) {
          window.open(activation.DigitalVideo, '_blank');
        }
      }
    }
  }

}
